import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=44d97ede&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44d97ede')) {
      api.createRecord('44d97ede', component.options)
    } else {
      api.reload('44d97ede', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=44d97ede&", function () {
      api.rerender('44d97ede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2EXhjePrdo8PR/JS/imageCarousel.vue"
export default component.exports